import { AppBar, Box, Container, Toolbar, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import HorizontalStepper from "./HorizontalStepper";

const StepperContainer = () => {
  const { t } = useTranslation();
  return (
    <Box sx={{ minHeight: "100vh", backgroundColor: "background.default" }}>
      <AppBar position="fixed" elevation={0}>
        <Toolbar>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {t("stepper.title")}
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="lg">
        <Box
          sx={{
            marginTop: { xs: 8, sm: 10 },
            paddingTop: 0,
            paddingBottom: 6,
          }}
        >
          <HorizontalStepper />
        </Box>
      </Container>
    </Box>
  );
};

export default StepperContainer;
